/* ==========================================================================
   "Customise This Product" — supports BOTH an inline card and a modal popup.
   Each instance has its own canvas. Save adds to cart then redirects to /cart.
   ========================================================================== */
(function () {
  'use strict';

  var FABRIC_CDN = 'https://cdnjs.cloudflare.com/ajax/libs/fabric.js/5.3.1/fabric.min.js';
  var fabricLoading = false;

  function ensureFabric(cb) {
    if (window.fabric && window.fabric.Canvas) { cb(); return; }
    if (!fabricLoading) {
      fabricLoading = true;
      var s = document.createElement('script'); s.src = FABRIC_CDN; document.head.appendChild(s);
    }
    var tries = 0;
    var iv = setInterval(function () {
      if (window.fabric && window.fabric.Canvas) { clearInterval(iv); cb(); }
      else if (++tries > 100) { clearInterval(iv); console.error('Fabric.js failed to load'); }
    }, 100);
  }

  function isShown(el) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    if (r.width < 3 || r.height < 3) return false;
    var cs = getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) === 0) return false;
    return true;
  }

  /* global helpers (read the main product image + product form) */
  function getActiveImage() {
    var main = document.querySelector('[data-tf-main-img]');
    if (main && (main.currentSrc || main.src)) return main.currentSrc || main.src;
    var best = null, bestArea = 0;
    document.querySelectorAll('.tf-gallery__main img').forEach(function (im) {
      if (!im.src && !im.currentSrc) return;
      if (!isShown(im)) return;
      var r = im.getBoundingClientRect(); var a = r.width * r.height;
      if (a > bestArea) { bestArea = a; best = im; }
    });
    return best ? (best.currentSrc || best.src) : null;
  }
  function getCurrentVariantId() {
    var hidden = document.querySelector('[data-tf-id]');
    if (hidden && hidden.value) return hidden.value;
    var r = document.querySelector('input[name="id"]:checked');
    var s = document.querySelector('select[name="id"]');
    var h = document.querySelector('form[action*="/cart/add"] input[name="id"]') || document.querySelector('input[name="id"]');
    if (r && r.value) return r.value;
    if (s && s.value) return s.value;
    if (h && h.value) return h.value;
    return new URLSearchParams(location.search).get('variant');
  }
  function getQuantity() {
    var q = document.querySelector('[data-tf-qty], input[name="quantity"]');
    var n = q ? parseInt(q.value, 10) : 1;
    return (n && n > 0) ? n : 1;
  }
  function dataURLToBlob(dataURL) {
    var parts = dataURL.split(';base64,');
    var contentType = parts[0].split(':')[1];
    var raw = window.atob(parts[1]);
    var arr = new Uint8Array(raw.length);
    for (var i = 0; i < raw.length; i++) arr[i] = raw.charCodeAt(i);
    return new Blob([arr], { type: contentType });
  }

  /* boot one customiser instance (inline or inside a modal) */
  function boot(box) {
    if (!box || box.__tfBooted) return;
    var canvasEl = box.querySelector('canvas');
    if (!canvasEl) return;
    box.__tfBooted = true;

    var canvas = new fabric.Canvas(canvasEl);
    var hatImageUrl = null;
    var uploadedLogo = null;
    var printArea = {
      left: parseInt(box.getAttribute('data-print-left'), 10) || 75,
      top: parseInt(box.getAttribute('data-print-top'), 10) || 90,
      width: parseInt(box.getAttribute('data-print-width'), 10) || 100,
      height: parseInt(box.getAttribute('data-print-height'), 10) || 80
    };

    function setBackground(url) {
      if (!url) return;
      fabric.Image.fromURL(url, function (img) {
        if (!img || !img.width) return;
        img.set({ selectable: false, evented: false });
        var size = 250; canvas.setWidth(size); canvas.setHeight(size);
        var scale = Math.min(size / img.width, size / img.height); img.scale(scale);
        canvas.setBackgroundImage(img, function () {
          if (uploadedLogo) canvas.bringToFront(uploadedLogo);
          canvas.renderAll();
        }, { originX: 'center', originY: 'center', left: size / 2, top: size / 2 });
      }, { crossOrigin: 'anonymous' });
    }
    function syncBackground() {
      var src = getActiveImage();
      if (src && src !== hatImageUrl) { hatImageUrl = src; setBackground(src); }
    }
    box.__sync = syncBackground;
    syncBackground();
    setTimeout(syncBackground, 400);

    var observer = new MutationObserver(syncBackground);
    observer.observe(document.body, { subtree: true, attributes: true, attributeFilter: ['class', 'style', 'src', 'aria-hidden', 'hidden'] });

    var chooseBtn = box.querySelector('[data-tf-choose]');
    var uploadInput = box.querySelector('[data-tf-upload]');
    var fileName = box.querySelector('[data-tf-filename]');
    if (chooseBtn && uploadInput) chooseBtn.addEventListener('click', function () { uploadInput.click(); });

    if (uploadInput) uploadInput.addEventListener('change', function (e) {
      if (!e.target.files.length) return;
      var f = e.target.files[0];
      if (fileName) fileName.textContent = f.name.length > 32 ? f.name.slice(0, 29) + '...' : f.name;
      var reader = new FileReader();
      reader.onload = function (ev) {
        fabric.Image.fromURL(ev.target.result, function (img) {
          if (uploadedLogo) canvas.remove(uploadedLogo);
          var maxWidth = printArea.width * 0.8; var scale = maxWidth / img.width;
          img.set({
            left: printArea.left + printArea.width / 2, top: printArea.top + printArea.height / 2,
            originX: 'center', originY: 'center', scaleX: scale, scaleY: scale,
            cornerStyle: 'circle', transparentCorners: false
          });
          img.on('moving', function () {
            if (img.left < printArea.left) img.left = printArea.left;
            if (img.top < printArea.top) img.top = printArea.top;
            if (img.left + img.getScaledWidth() > printArea.left + printArea.width) img.left = printArea.left + printArea.width - img.getScaledWidth();
            if (img.top + img.getScaledHeight() > printArea.top + printArea.height) img.top = printArea.top + printArea.height - img.getScaledHeight();
          });
          uploadedLogo = img; canvas.add(img); canvas.setActiveObject(img); canvas.renderAll();
        }, { crossOrigin: 'anonymous' });
      };
      reader.readAsDataURL(f);
    });

    var resetBtn = box.querySelector('[data-tf-reset]');
    if (resetBtn) resetBtn.addEventListener('click', function () {
      if (uploadedLogo) { canvas.remove(uploadedLogo); uploadedLogo = null; }
      if (uploadInput) uploadInput.value = '';
      if (fileName) fileName.textContent = 'No file chosen';
      var src = getActiveImage(); if (src) setBackground(src);
    });

    var saveBtn = box.querySelector('[data-tf-save]');
    if (saveBtn) saveBtn.addEventListener('click', function () {
      if (!uploadedLogo) { alert('Please upload your logo first.'); return; }
      var variantId = getCurrentVariantId();
      if (!variantId) { alert('Please select a size / colour first.'); return; }
      var original = saveBtn.textContent; saveBtn.textContent = 'Adding...'; saveBtn.disabled = true;

      var dataURL;
      try { dataURL = canvas.toDataURL({ format: 'png', quality: 0.9 }); }
      catch (err) { dataURL = uploadedLogo.toDataURL({ format: 'png' }); }

      var fd = new FormData();
      fd.append('id', variantId);
      fd.append('quantity', getQuantity());
      fd.append('properties[Custom Design]', new File([dataURLToBlob(dataURL)], 'custom-design.png', { type: 'image/png' }));
      fd.append('properties[_Product URL]', window.location.href);

      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';
      fetch(root + 'cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
        .then(function (res) { if (!res.ok) return res.json().then(function (d) { throw new Error(d.description || 'Could not add to cart'); }); return res.json(); })
        .then(function () { window.location.href = root + 'cart'; })
        .catch(function (e) { alert('Error: ' + e.message); saveBtn.textContent = original; saveBtn.disabled = false; });
    });
  }

  /* modal open/close */
  function getModal() { return document.querySelector('[data-tf-customizer-modal]'); }
  function openModal() {
    var modal = getModal(); if (!modal) return;
    modal.hidden = false; document.body.style.overflow = 'hidden';
    var box = modal.querySelector('[data-tf-customizer]');
    ensureFabric(function () { boot(box); if (box && box.__sync) box.__sync(); });
  }
  function closeModal() {
    var modal = getModal(); if (!modal) return;
    modal.hidden = true; document.body.style.overflow = '';
  }

  function initInline() {
    var inline = document.querySelector('[data-tf-customizer][data-mode="inline"]');
    if (inline) ensureFabric(function () { boot(inline); });
  }

  function init() {
    initInline();
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-tf-open-customizer]')) { e.preventDefault(); openModal(); }
      if (e.target.closest('[data-tf-cust-close]')) { closeModal(); }
    });
    document.addEventListener('keydown', function (e) {
      var modal = getModal();
      if (e.key === 'Escape' && modal && !modal.hidden) closeModal();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('[data-tf-customizer]').forEach(function (b) { b.__tfBooted = false; });
    initInline();
  });
})();
